import React from 'react';
import { Link } from "react-router-dom";
import home_photo from "../images/Diverticulitis_home_pg_pic-logo_5.png";

import { Container, Row, Navbar, Nav, Button } from "react-bootstrap";
import { useLocation } from 'react-router-dom';

function Header({ show_image = true }) {
    let location = useLocation();
    let { pathname } = location;

    return (
        <div className="banner hide-from-print fixed-top">
            <Container>
                <Row>
                    <Navbar expand="lg" className="header-nav">
                        {/* Logo or Home link */}
                        {show_image === true ? (
                            <Link className="img-transparent" to={"/"}>
                                <img src={home_photo} alt="Home" />
                            </Link>
                        ) : (
                            <Link className="img-transparent limit-opacity" to={"/"}>
                                <img src={home_photo} alt="Home" />
                            </Link>
                        )}

                        {/* Navbar Toggle (Hamburger Menu) */}
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                        {/* Collapsible Navbar Links */}
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="ml-auto">
                                {/* Treatment Options Link */}
                                <Link className="header-link text-wrap" to={"/treatment-options"}>
                                    <Button
                                        className={
                                            pathname === "/treatment-options"
                                                ? "header-selected-button"
                                                : ""
                                        }
                                    >
                                        {pathname === "/treatment-options"
                                            ? "Treatment Options"
                                            : "What are your treatment options?"}
                                    </Button>
                                </Link>

                                {/* Important Activities Link */}
                                <Link className="header-link text-wrap" to={"/activities"}>
                                    <Button
                                        className={
                                            pathname === "/activities" ? "header-selected-button" : ""
                                        }
                                    >
                                        {pathname === "/activities"
                                            ? "Important Activities"
                                            : "What activities are most important to you?"}
                                    </Button>
                                </Link>

                                {/* FAQ Link */}
                                <Link className="header-link text-wrap" to={"/faq"}>
                                    <Button
                                        className={pathname === "/faq" ? "header-selected-button" : ""}
                                    >
                                        {pathname === "/faq" ? "FAQ" : "Frequently Asked Questions"}
                                    </Button>
                                </Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Row>
            </Container>
        </div>
    );
}

export default Header;
